
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"bcx-icon-shadow",attrs:{"fill":"var(--background-color)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.678 30.965v7.717l3.335-1.667 3.334 1.667v-7.717"}}),_c('circle',{attrs:{"cx":"33.014","cy":"26.177","r":"5.836"}})]),_c('path',{attrs:{"d":"M24.676 37.015h-13.34a3.334 3.334 0 01-3.334-3.335V10.337a3.334 3.334 0 013.335-3.335h21.676a3.334 3.334 0 013.334 3.335v5.002M14.671 13.672h15.007M14.671 20.341h6.67M14.671 27.01h5.003"}})])
          )
        }
      }
    